import { Loader } from '@creditsights/styleguide-web';
import { ReactElement } from 'react';
import useFetchProfile from '../../../hooks/user/useFetchProfile';
import useFetchRoles from '../../../hooks/user/useFetchRoles';
import UserAccountHeader from '../UserAccountHeader';
import ChangePassword from './ChangePassword';
import PersonalInformation from './PersonalInformation';
import './Profile.scss';
import WorkAddress from './WorkAddress';

function Profile(): ReactElement {
  const { data: user, isLoading: isProfileLoading } = useFetchProfile();
  const { data: roles, isLoading: isRolesLoading } = useFetchRoles();

  if (!isProfileLoading && !isRolesLoading) {
    return (
      <div className="cs-user-profile-ctx">
        <UserAccountHeader />
        <PersonalInformation user={user} roles={roles} />
        <WorkAddress user={user} />
        <ChangePassword />
      </div>
    );
  }
  return <Loader className="cs-loader" position="center" />;
}

export default Profile;
